<template>
    <div class="ag-cell-edit-wrapper">
        <div role="presentation" class="ag-cell-editor ag-labeled ag-label-align-left ag-text-field ag-input-field">
            <div class="ag-wrapper lx-edit-no-underline" role="presentation">
                <input
                    ref="input"
                    :value="value"
                    @keydown="onKeyDown($event)"
                    @input="onInput"
                    class="ag-input-field-input"
                    :class="dynamicWidth"
                /><b-form-select
                    v-if="selectOneOptions.length > 0"
                    v-model="selectOneValue"
                    class="ag-input-field-select"
                    :class="dynamicWidth"
                    :options="selectOneOptions"
                /><b-form-select
                    v-if="selectTwoOptions.length > 0 && isVisible()"
                    v-model="selectTwoValue"
                    class="ag-input-field-select"
                    :class="dynamicWidth"
                    :options="selectTwoOptions"
                />                
            </div>
        </div>
    </div>
</template>

<script>
    const BACKSPACE_CHAR_CODE = 8;
    const DELETE_CHAR_CODE = 46;
    const DOT_CHAR_CODE = 190;
    const PASTE_CHAR_CODE = 'PASTE';
    const ENTER_KEY = 13;
    const ARROW_KEYS = [37, 38, 39, 40];
    

    export default {
        data() {
            return {
                value: '',
                selectOneValue: null,
                selectTwoValue: null,
                cancelBeforeStart: true,
            };
        },
        computed: {
            isDecimal() {
                return !!this.params.isDecimal;
            },
            isNumeric() {
                return !!this.params.isNumeric;
            },
            isNegative() {
                return this.params.isNegative || false;
            },
            maxNumber() {
                return this.params.maxNumber || 0;
            },
            maxDecimalPlaces() {
                return this.params.maxDecimalPlaces || 2;
            },
            empty() {
                return !!this.params.empty;
            },
            emptyValue() {
                return 'emptyValue' in this.params
                    ? this.params.emptyValue
                    : '';
            },
            dynamicWidth() {
                if (this.selectOneOptions.length == 0 && this.selectTwoOptions.length == 0) {
                    return 'w-100';
                } else if (this.selectOneOptions.length > 0 && this.selectTwoOptions.length > 0 && this.isVisible()) {
                    return 'w-33';
                } else if (this.selectOneOptions.length > 0 || (this.selectTwoOptions.length > 0 && this.isVisible())) {
                    return 'w-50';
                }
            },
        },
        methods: {
            getValue() {
                const value = this.value === ''
                    ? this.emptyValue
                    : this.value;

                if (this.selectOneOptions.length > 0 && this.selectTwoOptions.length > 0) {
                    return [value, this.selectOneValue, this.selectTwoValue];
                } else if (this.selectOneOptions.length > 0) {
                    return [value, this.selectOneValue];
                }
                return value;
            },
            isCancelBeforeStart() {
                return this.cancelBeforeStart;
            },
            isCancelAfterEnd() {
                return this.maxNumber && this.value > this.maxNumber;
            },
            onKeyDown(event) {
                if (this.isNumeric && !this.isKeyPressedNumeric(event)) {
                    if (event.preventDefault) event.preventDefault();
                } else if (this.isDecimal && !this.isKeyPressedDecimal(event)) {
                    if (event.preventDefault) event.preventDefault();
                }
            },
            onInput(event) {
                if (event.target.value === '' && this.empty) {
                    this.value = '';
                    return;
                }
                if (this.isDecimal && !this.isValidDecimal(event.target.value)) {
                    return;
                }
                if (this.isNumeric && !this.isValidNumeric(event.target.value)) {
                    return;
                }                
                this.value = event.target.value;
            },
            getCharCodeFromEvent(event) {
                event = event || window.event;
                if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
                    return 'PASTE';
                }
                return typeof event.which === 'undefined' ? event.keyCode : event.which;            
            },
            isValidDecimal(str) {
                if (this.isNegative) {
                    return new RegExp(`^-?\\d+(\\.\\d{1,${this.maxDecimalPlaces}})?$`).test(str);
                }
                else {
                    return new RegExp(`^\\d+(\\.\\d{1,${this.maxDecimalPlaces}})?$`).test(str);
                }
            },
            isValidNumeric(str) {
                if (this.isNegative) {
                    return /^-?\d+$/.test(str);
                }
                else {
                    return /^\d+$/.test(str);
                }
            },            
            isCharNumeric(charStr) {
                if (this.isNegative) {
                    return /\d/.test(charStr);
                }
                else {
                    return /\d/.test(charStr);
                }
            },
            isCharDecimal(charStr) {
                if (this.isNegative) {
                    return /-?[\d\.]/.test(charStr);
                }
                else {
                    return /[\d\.]/.test(charStr);
                }
            },
            isKeyPressedNumeric(event) {
                const charCode = this.getCharCodeFromEvent(event);
                if (
                    charCode === BACKSPACE_CHAR_CODE ||
                    charCode === DELETE_CHAR_CODE ||
                    charCode === ENTER_KEY ||
                    charCode === PASTE_CHAR_CODE ||
                    ARROW_KEYS.includes(charCode)
                ) {
                    return true;
                }
                let charStr = event.key || String.fromCharCode(charCode)
                charStr = charCode === DOT_CHAR_CODE ? '.' : charStr;
                if (this.isNegative && charStr === '-') {
                    return true;
                }                         
                return this.isCharNumeric(charStr);
            },
            isKeyPressedDecimal(event) {
                const charCode = this.getCharCodeFromEvent(event);
                if (
                    charCode === BACKSPACE_CHAR_CODE ||
                    charCode === DELETE_CHAR_CODE ||
                    charCode === ENTER_KEY ||
                    charCode === PASTE_CHAR_CODE ||
                    ARROW_KEYS.includes(charCode)
                ) {
                    return true;
                }
                let charStr = event.key || String.fromCharCode(charCode)
                charStr = charCode === DOT_CHAR_CODE ? '.' : charStr;
                if (this.isNegative && charStr === '-') {
                    return true;
                }                             
                return this.isCharDecimal(charStr);
            },
            isVisible() {
                if (this.selectTwoVisibleCallback != null) {
                    return this.selectTwoVisibleCallback(this.selectOneValue, this.selectTwoValue, );
                }
                return true;
            },
            isPopup() {
                return false;
            }
        },
        created() {
            this.value = this.params.value;
            this.selectOneValue = this.params.selectOneValue;
            this.selectTwoValue = this.params.selectTwoValue;
            this.selectOneOptions = this.params.selectOneOptions || [];
            this.selectTwoOptions = this.params.selectTwoOptions || [];
            this.selectTwoVisibleCallback = this.params.selectTwoVisibleCallback || null;

            // only start edit if key pressed is a number, not a letter
            this.cancelBeforeStart = this.params.charPress && '1234567890'.indexOf(this.params.charPress) < 0;
        },
        mounted() {
            this.$nextTick(() => {
                // need to check if the input reference is still valid - if the edit was cancelled before it started there
                // wont be an editor component anymore
                if (this.$refs.input) {
                    this.$refs.input.focus();
                    if (this.params.select) {
                        this.$refs.input.select();
                    }
                }
            });
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.ag-input-field-input) {
        color: #404040 !important;
        text-decoration: none !important;
    }

    :deep(.ag-input-field-select) {
        color: #404040 !important;
        text-decoration: none !important;

        border: none;
        width: 100%;
        height: 100%;
        margin-left:3px;
    }
    
    :deep(.w-33) {
        width: 33% !important;
    }
    
    :deep(.custom-select) {
        height: auto !important;
        vertical-align: unset !important;
        padding: 1px 0 0 0 !important;
        line-height: 2.1 !important;
    }
    
    :deep(.lx-edit-no-underline) {
        text-decoration: none !important;
    }
</style>
